module.exports = __webpack_public_path__ + "static/media/400014_01.1394dcac.png";